import { render, staticRenderFns } from "./mc-msl-prompt.vue?vue&type=template&id=0d842372&scoped=true"
import script from "./mc-msl-prompt.vue?vue&type=script&lang=ts"
export * from "./mc-msl-prompt.vue?vue&type=script&lang=ts"
import style0 from "./mc-msl-prompt.vue?vue&type=style&index=0&id=0d842372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d842372",
  null
  
)

export default component.exports